export HomeView from "./HomeView"
export UsersView from "./UsersView"
export NewUserView from "./NewUserView"
export ProductsView from "./ProductsView"
export ProductDetailView from "./detail/ProductDetailView"
export NewProductView from "./NewProductView"
export ArticlesView from "./ArticlesView"
export ArticleDetailView from "./detail/ArticleDetailView"
export NewArticleView from "./NewArticleView"
export WarehouseView from "./WarehouseView"
export AreaDetailView from "./detail/AreaDetailView"
export NewAreaView from "./NewAreaView"
export LocationDetailView from "./detail/LocationDetailView"
export OrderDetailView from "./detail/OrderDetailView"
export NewLocationView from "./NewLocationView"
export LoginView from "./LoginView"

export SignupView from "./SignupView"
export ForgotPasswordView from "./ForgotPasswordView"
export ResetPasswordView from "./ResetPasswordView"
export SettingsView from "./SettingsView"
export ShoppingCartView from "./ShoppingCartView"
export DestinationsView from "./DestinationsView"
export DestinationDetailView from "./detail/DestinationDetailView"
export NewDestinationView from "./NewDestinationView"
export TransactionsView from "./TransactionsView"
export TransactionDetailView from "./detail/TransactionDetailView"
export TenantsView from "./TenantsView"
export TenantDetailView from "./detail/TenantDetailView"
export NewTenantView from "./NewTenantView"
export DeliveryNotesView from "./DeliveryNotesView"
export DeliveryNoteDetailView from "./detail/DeliveryNoteDetailView"
export ArticleStockOutView from "./detail/ArticleStockOutView"
export ArticleMovementView from "./detail/ArticleMovementView"
export ArticleStockUpView from "./detail/ArticleStockUpView"
export InventoriesView from "./InventoriesView"



// WEBPACK FOOTER //
// ./src/views/index.js